import { provide } from 'vue';
import { useVuelidate } from '@vuelidate/core';

export function useValidation(validations: Record<string, any>, values: Record<string, any>) {
  const $v = useVuelidate(validations, values);

  provide('validations', $v);

  return $v;
}
